import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { FAQS_FETCH } from "../actions/types";
import { faqsFetchSuccess } from "../actions/";
// import { showErrorMessage } from "../actions/NotifyActions";
import { authorizationHeader } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
const faqsFetchRequest = async () => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/faqs`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// WORKER
function* faqsFetch({ payload }) {
  try {
    const data = yield call(faqsFetchRequest, payload);
    yield put(faqsFetchSuccess(data));
  } catch (error) {
    // yield put(showErrorMessage(getErrorMessage_v2(error.response)));
  }
}

// WATCHER
function* faqsFetchWatcher() {
  yield takeEvery(FAQS_FETCH, faqsFetch);
}

export default function* rootSaga() {
  yield all([fork(faqsFetchWatcher)]);
}
